export default __webpack_public_path__ + "static/media/jp.a714888a.svg";